// Track Email Signup Block form submissions
jQuery( document ).ready( function ( $ ) {
	$( '.email-signup__action button' ).click( function () {
		if ( typeof window.ncst != 'object' ) return;

		var label =
			'Form ID: ' +
			$( this ).siblings( 'input:hidden[name=gform_submit]' ).val();
		window.ncst.controllers.analytics.broadcastEvent( 'ncst.formSubmit', {
			category: 'Email Signup Block',
			action: 'Form Submit',
			label: label,
		} );
	} );
} );
